<template>
    <va-edit-layout>
        <RefundEventShipmentItemFee-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventShipmentItemFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
